import Api from "../../../services/api";

export function loadForm(params, cb) {
    return (dispatch) => {
        Api.put('/w06f4210/load-form', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}

export function deleteRow(params, cb) {
    return (dispatch) => {
        Api.delete('/w06f4210/delete', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}

export function save(params, cb) {
    return (dispatch) => {
        Api.put('/w06f4210/save', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}
